// Variations are offering-level and shared by every car. "+ Add new variation" on a second car
// creates a second pool entry, so two cars can end up with the same name twice; the server
// rejects that (409 DUPLICATE_VARIATION_NAME). Catch it before the save, with the same wording.

interface NamedVariation {
  name: string;
  values: { label: string }[];
}

const norm = (s: string) => s.trim().toLowerCase();

/** First duplicate variation name, or duplicate value label within one variation; null if none. */
export function duplicateVariationError(variations: NamedVariation[]): string | null {
  const names = new Set<string>();
  for (const v of variations) {
    const key = norm(v.name);
    if (!key) continue;
    if (names.has(key)) {
      return `You already have a variation called "${v.name.trim()}" on this service. `
        + 'To use it on another car, pick it from "Select existing variation" instead of adding a new one.';
    }
    names.add(key);
  }
  for (const v of variations) {
    const labels = new Set<string>();
    for (const val of v.values) {
      const key = norm(val.label);
      if (!key) continue;
      if (labels.has(key)) {
        return `The variation "${v.name.trim()}" has the value "${val.label.trim()}" more than once. `
          + 'Give each value a different name.';
      }
      labels.add(key);
    }
  }
  return null;
}
